import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M19.491 8.127c-.078 1.513-1.123 3.592-3.158 6.228-2.113 2.747-3.903 4.126-5.35 4.126-.9 0-1.667-.845-2.29-2.513a310 310 0 0 0-1.257-4.593C6.98 9.707 6.48 8.86 5.946 8.86c-.122 0-.523.256-1.212.734L4 8.64c.767-.678 1.524-1.346 2.258-2.024 1.011-.9 1.779-1.357 2.301-1.401 1.213-.134 1.947.69 2.236 2.469.3 1.901.522 3.102.623 3.558.355 1.58.722 2.38 1.156 2.38.322 0 .812-.523 1.468-1.535.645-1.034 1-1.812 1.045-2.346.09-.89-.255-1.334-1.045-1.334-.367 0-.756.088-1.157.255.757-2.502 2.202-3.725 4.36-3.658 1.601.044 2.346 1.078 2.246 3.113v.011Z",
      fill: "#616a75"
    }, null, -1)
  ])))
}
export default { render };